import { Demand, GenAI } from "../../../assets/svg-icons";
import { processNodeAndPermissions } from "../../../helper/com-helper";

const GENAI_OBJECT = {
    name: "Cortex",
    route: "/agentic-ai/dashboard",
    permissions: ["GENAI_VIEW"],
    child: {
        Agents: {
            name: "Agents",
            shortName: "Agents",
            route: null,
            icon: Demand,
            permissions: [],
            child: {
                "Agent List": {
                    name: "Agent List",
                    route: "/agentic-ai/agent-table",
                    permissions: ["GENAI_VIEW"],
                },
                "Create New": {
                    name: "Create New",
                    route: "/agentic-ai/createnewagent",
                    permissions: ["GENAI_VIEW"],
                },
                Pilot: {
                    name: "Pilot",
                    route: "/agentic-ai/pilot",
                    permissions: ["GENAI_VIEW"],
                },
                Playground: {
                    name: "Playground",
                    route: "/agentic-ai/playground",
                    permissions: ["GENAI_VIEW"],
                },
            },
        }
    },
    extraRoutes: [
        {
            route: "/agentic-ai/dashboard",
            permissions: ["GENAI_VIEW"],
            roles: [],
        },
        {
            route: "/agentic-ai/agent-table",
            permissions: ["GENAI_VIEW"],
            roles: [],
        },
        {
            route: "/agentic-ai/agent-details/:agentKey",
            permissions: ["GENAI_VIEW"],
            roles: [],
        },
        {
            route: "/agentic-ai/gauri-new-chat",
            permissions: ["GENAI_VIEW"],
            roles: [],
        },
        {
            route: "/agentic-ai/main-chat",
            permissions: ["GENAI_VIEW"],
            roles: [],
        },
        {
            route: "/agentic-ai/configuration",
            permissions: ["GENAI_VIEW"],
            roles: [],
        },
        {
            route: "/agentic-ai/configuration/form",
            permissions: ["GENAI_VIEW"],
            roles: [],
        },
        {
            route: "/agentic-ai/risk-table",
            permissions: ["GENAI_VIEW"],
            roles: [],
        },
        {
            route: "/agentic-ai/monitoring",
            permissions: ["GENAI_VIEW"],
            roles: [],
        },
        {
            route: "/agentic-ai/monitoring-prompt",
            permissions: ["GENAI_VIEW"],
            roles: [],
        },
        {
            route: "/agentic-ai/monitoring-detail/:userId",
            permissions: ["GENAI_VIEW"],
            roles: [],
        },
        {
            route: "/agentic-ai/insights",
            permissions: ["GENAI_VIEW"],
            roles: [],
        },
        {
            route: "/agentic-ai/history",
            permissions: ["GENAI_VIEW"],
            roles: [],
        },
    ],
};

processNodeAndPermissions(GENAI_OBJECT);
export const GENAI = GENAI_OBJECT;
